'use strict';

export default class ConferenceController {
    constructor () {
        {
            this.harkOptions = {
                interval: 10,
                threshold: -50
            };
        }

        {
            this.addUserEvent = new CustomEvent('canvas.addUser', {
                "detail": {userId: ''}
            });

            this.removeUserEvent = new CustomEvent('canvas.removeUser', {
                "detail": {userId: ''}
            });

            this.updateConferenceStatusEvent = new CustomEvent('canvas.updateStatus', {
                "detail": {conferenceStatus: false}
            })
        }

    }

    initializeConference(initialize) {
        throw new Error('subclass responsibility');
    }

    muteAudio(value) {
        throw new Error('subclass responsibility');
    }

    muteMicrophone(value) {
        throw new Error('subclass responsibility');
    }

    endConnectionOfThisUser(userId) {
        throw new Error('subclass responsibility');
    }

    // server message handler
    handleClientFailure(userId) {
        throw new Error('subclass responsibility');
    }

    stopConference() {
        throw new Error('subclass responsibility');
    }

    handleEndCall(userId) {
        throw new Error('subclass responsibility');
    }
}